"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_day_picker_1 = require("react-day-picker");
var date_fns_1 = require("date-fns");
var locale_1 = require("date-fns/locale");
var chevron_left_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_left"));
var chevron_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_right"));
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var capitalize_1 = require("../../utils/estilos/functions/capitalize");
var S = __importStar(require("./LftCalendar.styles"));
var formatWeekdayName = function (weekDay) {
    return (0, date_fns_1.format)(weekDay, 'EEE', { locale: locale_1.ptBR }).charAt(0).toUpperCase();
};
var LftCalendar = function (_a) {
    var disabledDays = _a.disabledDays, selectedMonth = _a.selectedMonth, selectedDays = _a.selectedDays, _b = _a.eventDays, eventDays = _b === void 0 ? [] : _b, fromDate = _a.fromDate, _c = _a.mode, mode = _c === void 0 ? "single" : _c, toDate = _a.toDate, _d = _a.today, today = _d === void 0 ? new Date() : _d, _e = _a.showOutsideDays, showOutsideDays = _e === void 0 ? true : _e, lftRenderDayWrapper = _a.lftRenderDayWrapper, lftDayClick = _a.lftDayClick, lftMonthChange = _a.lftMonthChange;
    var _f = (0, react_1.useState)(selectedDays ? selectedDays : mode === "single" ? [today] : []), selectedDaysLocal = _f[0], setSelectedDaysLocal = _f[1];
    var _g = (0, react_1.useState)(selectedMonth ? selectedMonth : today), selectedMonthLocal = _g[0], setSelectedMonthLocal = _g[1];
    var _h = (0, react_1.useState)(selectedDays ? selectedDays : { from: undefined, to: undefined }), selectedRange = _h[0], setSelectedRange = _h[1];
    var _j = (0, react_1.useState)({ from: undefined, to: undefined }), hoverRange = _j[0], setHoverRange = _j[1];
    (0, react_1.useEffect)(function () {
        setSelectedDaysLocal(selectedDays ? selectedDays : mode === "single" ? [today] : []);
        setSelectedRange({ from: undefined, to: undefined });
        setHoverRange({ from: undefined, to: undefined });
    }, [mode, selectedDays]);
    (0, react_1.useEffect)(function () {
        setSelectedMonthLocal(selectedMonth ? selectedMonth : today);
    }, [selectedMonth]);
    var getDatesWithinRange = function (start, end) {
        var initialDate = start <= end ? start : end;
        var endDate = start >= end ? start : end;
        var currentDate = initialDate;
        var datesWithinRange = [];
        while (currentDate <= endDate) {
            datesWithinRange.push(currentDate);
            currentDate = new Date(currentDate);
            currentDate.setDate(currentDate.getDate() + (1));
        }
        return datesWithinRange;
    };
    var handleDayMouseEnter = function (day) {
        if (mode === "range" || mode === "multiple-range") {
            if ((selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) && (selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to)) {
                return;
            }
            else if (selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) {
                setHoverRange({ from: selectedRange.from, to: day });
            }
        }
    };
    var handleDayMouseLeave = function () {
        if (mode === "range" || mode === 'multiple-range') {
            setHoverRange({ from: undefined, to: undefined });
        }
    };
    var handleDayClick = function (date, modifiers) {
        if (mode === "multiple-range" && Array.isArray(selectedDaysLocal)) {
            if (modifiers.selected) {
                if (!selectedDaysLocal.find(function (localDate) { return (0, date_fns_1.isSameDay)(localDate, date); })) {
                    var newSelectedDays = __spreadArray(__spreadArray([], selectedDaysLocal, true), [date], false);
                    setSelectedDaysLocal(newSelectedDays);
                    lftDayClick && lftDayClick(newSelectedDays);
                }
                else {
                    var newSelectedDays = selectedDaysLocal.filter(function (localDate) { return !(0, date_fns_1.isSameDay)(localDate, date); });
                    setSelectedDaysLocal(newSelectedDays);
                    lftDayClick && lftDayClick(newSelectedDays);
                }
                setSelectedRange({ from: undefined, to: undefined });
            }
            else if (!selectedRange.from || (selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) && (selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to)) {
                setSelectedRange({ from: date, to: undefined });
            }
            else if (!selectedRange.to) {
                var newSelectedDays = __spreadArray(__spreadArray([], selectedDaysLocal, true), getDatesWithinRange(selectedRange.from, date), true);
                var uniqueSelectedDays = newSelectedDays.filter(function (value, index, self) {
                    return self.findIndex(function (date) { return date.toDateString() === value.toDateString(); }) === index;
                });
                setSelectedRange(__assign(__assign({}, selectedRange), { to: date }));
                setSelectedDaysLocal(uniqueSelectedDays);
                lftDayClick && lftDayClick(uniqueSelectedDays);
            }
        }
        else {
            if (mode === "range") {
                setSelectedRange(function (prevRange) { return (__assign(__assign({}, prevRange), date)); });
                setSelectedDaysLocal(date);
                lftDayClick && lftDayClick(date);
            }
            else if (mode === "multiple") {
                setSelectedDaysLocal(date);
                lftDayClick && lftDayClick(date);
            }
            else if (typeof date !== undefined && date !== undefined) {
                setSelectedDaysLocal([date]);
                handleMonthChange(date);
                lftDayClick && lftDayClick(date);
            }
        }
    };
    var handleMonthChange = function (e) {
        if (typeof e !== undefined) {
            setSelectedMonthLocal(e);
            if (!(0, date_fns_1.isSameMonth)(selectedMonthLocal, e)) {
                lftMonthChange && lftMonthChange(e);
            }
        }
    };
    var CustomCaption = function (props) {
        var _a = (0, react_day_picker_1.useNavigation)(), nextMonth = _a.nextMonth, previousMonth = _a.previousMonth;
        var month = (0, date_fns_1.format)(props.displayMonth, "MMMM 'de' y", { locale: locale_1.ptBR }).toString();
        var day = (0, date_fns_1.format)(today ? today : new Date(), "EEEE',' d 'de' MMMM", { locale: locale_1.ptBR });
        return ((0, jsx_runtime_1.jsxs)(S.CalendarHeader, __assign({ className: 'rdp-caption' }, { children: [(0, jsx_runtime_1.jsx)(LftIconButton_1.default, { alt: "M\u00EAs Anterior", ariaLabel: "M\u00EAs Anterior", disabled: !previousMonth, icon: chevron_left_1.default, size: 'lg', lftClick: function () { return previousMonth && handleMonthChange(previousMonth); } }, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'rdp-header' }, { children: [(0, jsx_runtime_1.jsx)(S.CalendarTitle, { children: (0, capitalize_1.capitalizeFirstLetter)(month) }, void 0), (0, jsx_runtime_1.jsx)(S.CalendarSubtitle, { children: (0, capitalize_1.capitalizeFirstLetter)(day) }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { alt: "Pr\u00F3ximo M\u00EAs", ariaLabel: "Pr\u00F3ximo M\u00EAs", disabled: !nextMonth, icon: chevron_right_1.default, size: 'lg', lftClick: function () { return nextMonth && handleMonthChange(nextMonth); } }, void 0)] }), void 0));
    };
    var CustomDay = function (props) {
        var date = props.date.getDate();
        var content = ((0, jsx_runtime_1.jsx)("div", __assign({ className: "rdp-day-text" }, { children: date }), void 0));
        return lftRenderDayWrapper ? lftRenderDayWrapper(props, content) : content;
    };
    var DayPickerProps = {
        'data-lift': 'lft-calendar',
        components: { Caption: CustomCaption, DayContent: CustomDay },
        defaultMonth: selectedMonthLocal,
        disabled: disabledDays,
        formatters: { formatWeekdayName: formatWeekdayName },
        locale: locale_1.ptBR,
        mode: mode,
        modifiersClassNames: { event: 'rdp-event', hoverRange: 'rdp-range-hover' },
        month: selectedMonthLocal,
        showOutsideDays: showOutsideDays,
        today: today,
        fromDate: fromDate,
        toDate: toDate,
        onMonthChange: handleMonthChange
    };
    (0, react_1.useEffect)(function () {
        if (selectedDays) {
            setSelectedDaysLocal(selectedDays);
        }
    }, [selectedDays]);
    if (mode === "multiple-range" && Array.isArray(selectedDaysLocal)) {
        return ((0, jsx_runtime_1.jsx)(S.CalendarWrapper, __assign({ "data-lift": "lft-calendar" }, { children: (0, jsx_runtime_1.jsx)(react_day_picker_1.DayPicker, __assign({ selected: __spreadArray([selectedRange], selectedDaysLocal, true), onDayClick: handleDayClick, onDayMouseEnter: function (e) { return handleDayMouseEnter(e); }, onDayMouseLeave: function () { return handleDayMouseLeave(); }, modifiers: { event: eventDays, hoverRange: hoverRange } }, DayPickerProps), void 0) }), void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(S.CalendarWrapper, __assign({ "data-lift": "lft-calendar" }, { children: (0, jsx_runtime_1.jsx)(react_day_picker_1.DayPicker, __assign({ selected: selectedDaysLocal, onSelect: handleDayClick, onDayMouseEnter: function (e) { return handleDayMouseEnter(e); }, onDayMouseLeave: function () { return handleDayMouseLeave(); }, modifiers: { event: eventDays, hoverRange: mode === "range" ? hoverRange : [] } }, DayPickerProps), void 0) }), void 0));
    }
};
exports.default = LftCalendar;
